import { render } from "./list-client-access.vue?vue&type=template&id=72ee2f62"
import script from "./list-client-access.vue?vue&type=script&lang=js"
export * from "./list-client-access.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__